// Init i18n (defaults + translate())
import "./utils/i18n";

// Sections
import "./sections/main-product";

// Snippets
import "./snippets/product-card";
import "./snippets/discount-bar/discount-bar";
import "./snippets/progress-bar/progress-bar";
import "./snippets/quantity-change-warning/quantity-change-warning";
import "./snippets/product-groups";
import "./snippets/bundle-group-by-tag";
import "./snippets/tiered-pricing/tiered-pricing";

// Components
import "./components/quantity-input-buttons/quantity-input-buttons";
import "./components/fix-bundle-clicker";
import "./components/afterpay";
import "./components/announcement-bar-overwrite";

// Utils
import "./utils/fixDiscountsAfterLogin";
